import axios, { AxiosError } from 'axios'
import config, { defaultRequestInterceptors, defaultResponseInterceptors } from './config'

import { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig, RequestConfig } from './types'
import { ElMessage } from 'element-plus'
import { useStorage } from '@/hooks/web/useStorage'
import { useRoute } from 'vue-router'
import { getQueryParam } from '@/utils/tools.js'

const route = useRoute()
const { removeStorage } = useStorage('localStorage')
const { getStorage } = useStorage()

const { interceptors, baseUrl, pointBaseUrl } = config

const { requestInterceptors, responseInterceptors } = interceptors

const abortControllerMap: Map<string, AbortController> = new Map()

const axiosInstance: AxiosInstance = axios.create({
  ...config,
  baseURL: baseUrl
})
axiosInstance.interceptors.request.use((res: InternalAxiosRequestConfig) => {
  const controller = new AbortController()
  const url = res.url || ''
  res.signal = controller.signal
  abortControllerMap.set(url, controller)

  return res
})
axiosInstance.interceptors.response.use(
  (res: AxiosResponse) => {
    const url = res.config.url || ''
    abortControllerMap.delete(url)
    return res
  },
  (error: AxiosError) => {
    console.log('AxiosError', error.response?.status, window.location.href)
    console.log('AxiosError1', error)
    if (error?.response?.status === 401) {
      // ElMessage.error(error.response.data?.message)
      // token过期
      // clear()
      // clearTimeout(timeout);
      // timeout = setTimeout(()=>{
      // window.location.reload()
      // },1000)
      if (window.location.href.includes('/personal/')) {
        console.log('personal1', getQueryParam('type'))
        const _arr: any = window.location.href.split('/')
        let id: any = _arr[_arr.length - 1]
        if (getQueryParam('type')) {
          id = id.split('&')[0]
          window.location.href = window.location.protocol + '//' + window.location.host + '/commodity/' + id
        } else {
          window.location.href = window.location.protocol + '//' + window.location.host + '/' + id
        }
        return
      }
      if (/\/commodity\/|\/coupon\//.test(window.location.href)) {
        removeStorage('loginInfo_' + useStorage('sessionStorage').getStorage('clientId'))
      } else if (/\/column\//.test(window.location.href)) {
        removeStorage('loginInfo_' + getStorage('columnId'))
      } else {
        removeStorage('loginInfo_' + getStorage('roomId'))
      }
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    } else {
      console.log('err： ' + error) // for debug
      if (
        error?.response?.status != 402 &&
        error?.response?.config.url != '/reportErrorLog' &&
        !error.message.includes('Network Error')
      ) {
        ElMessage.error(error.message)
      }
      if (error.message == '微信授权失败') {
        console.log('ccc2', window.location.host + '/' + route.params.id)
        useStorage('localStorage').removeStorage(`wxLoginTime_${getStorage('clientId')}`)
        window.location.href = window.location.protocol + '//' + window.location.host + '/' + route.params.id
      }
    }
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.request.use(requestInterceptors || defaultRequestInterceptors)
axiosInstance.interceptors.response.use(responseInterceptors || defaultResponseInterceptors)

// 埋点服务
const axiosInstancePonint: AxiosInstance = axios.create({
  ...config,
  baseURL: pointBaseUrl
})

axiosInstancePonint.interceptors.request.use((res: InternalAxiosRequestConfig) => {
  const controller = new AbortController()
  const url = res.url || ''
  res.signal = controller.signal
  abortControllerMap.set(url, controller)
  return res
})
axiosInstancePonint.interceptors.response.use(
  (res: AxiosResponse) => {
    const url = res.config.url || ''
    abortControllerMap.delete(url)
    return res
  },
  (error: AxiosError) => {
    console.log('AxiosError', error.response?.status, window.location.href)
    if (error?.response?.status === 401) {
      // ElMessage.error(error.response.data?.message)
      // token过期
      // clear();
      if (window.location.href.includes('/personal/')) {
        console.log('personal1', getQueryParam('type'))
        const _arr: any = window.location.href.split('/')
        let id: any = _arr[_arr.length - 1]
        if (getQueryParam('type')) {
          id = id.split('&')[0]
          window.location.href = window.location.protocol + '//' + window.location.host + '/commodity/' + id
        } else {
          window.location.href = window.location.protocol + '//' + window.location.host + '/' + id
        }
        return
      }
      removeStorage('loginInfo_' + getStorage('roomId'))
      window.location.reload()
    } else {
      console.log('err： ' + error) // for debug
      if (error?.response?.status != 402) {
        ElMessage.error(error.message)
      }
      if (error.message == '微信授权失败') {
        console.log('ccc1', window.location.host + '/' + route.params.id)
        useStorage('localStorage').removeStorage(`wxLoginTime_${getStorage('clientId')}`)
        window.location.href = window.location.protocol + '//' + window.location.host + '/' + route.params.id
      }
    }
    return Promise.reject(error)
  }
)

axiosInstancePonint.interceptors.request.use(requestInterceptors || defaultRequestInterceptors)
axiosInstancePonint.interceptors.response.use(responseInterceptors || defaultResponseInterceptors)

const service = {
  request: (config: RequestConfig) => {
    return new Promise((resolve, reject) => {
      if (config.interceptors?.requestInterceptors) {
        config = config.interceptors.requestInterceptors(config as any)
      }

      axiosInstance
        .request(config)
        .then(res => {
          resolve(res)
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },

  pointRequest: (config: RequestConfig) => {
    return new Promise((resolve, reject) => {
      if (config.interceptors?.requestInterceptors) {
        config = config.interceptors.requestInterceptors(config as any)
      }

      axiosInstancePonint
        .request(config)
        .then(res => {
          resolve(res)
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  cancelRequest: (url: string | string[]) => {
    const urlList = Array.isArray(url) ? url : [url]
    for (const _url of urlList) {
      abortControllerMap.get(_url)?.abort()
      abortControllerMap.delete(_url)
    }
  },
  cancelAllRequest() {
    for (const [_, controller] of abortControllerMap) {
      controller.abort()
    }
    abortControllerMap.clear()
  }
}

export default service
